// extracted by mini-css-extract-plugin
export default {"mobileNavHeader":"MobileNavbarHeader_mobileNavHeader__Pgbl3"};